import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { EnvironmentService } from "../environment/environment.service";
import { SessionService } from "../session/session.service";
import { BootstrapService } from "../bootstrap.service";
import { AlertService } from "../../shared/alert/alert.service";
import { ItauUserIdleService } from "../security/itau-user-idle.service";
import { mergeMap, retryWhen } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../environment/environment.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../session/session.service";
import * as i4 from "../bootstrap.service";
import * as i5 from "../../shared/alert/alert.service";
import * as i6 from "../security/itau-user-idle.service";
var gestorTokenUrl = "/api/oauth/gestorToken?code=";
var signOnOk4 = "/ok4menu/Login.aspx/LoginEn4";
var ok4Logout = "/ok4menu/Login.aspx/SairEn4";
var AuthService = /** @class */ (function () {
    function AuthService(environmentService, http, sessionService, bootstrapService, alertService, userIdleService) {
        this.environmentService = environmentService;
        this.http = http;
        this.sessionService = sessionService;
        this.bootstrapService = bootstrapService;
        this.alertService = alertService;
        this.userIdleService = userIdleService;
        this.redirectUriPath = "";
        this.idleUserValidationHasStarted = false;
        this.authSubject = new BehaviorSubject(null);
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlAuth;
        this.apiUrlMenu = this.environmentService.envModel.appSettings.apiUrlMenu;
        this.apiOK4 = this.environmentService.envModel.appSettings.apiOK4;
        this.authSettings = this.environmentService.envModel.authSettings;
    }
    AuthService.prototype.buildUrl = function () {
        return this.authSettings.openIdUrl + "?client_id=" + this.authSettings.client_id + "&redirect_uri=" + this.authSettings.redirect_uri + this.pathValue + "&response_type=" + this.authSettings.response_type + "&scope=" + this.authSettings.scope;
    };
    AuthService.prototype.getAuthModel = function () {
        this.authSubject.next(this.sessionService.getAuthUser());
        return this.authSubject;
    };
    Object.defineProperty(AuthService.prototype, "currentUserValue", {
        get: function () {
            this.authSubject.next(this.sessionService.getAuthUser());
            return this.authSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "authenticatedUser", {
        get: function () {
            return this.authSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.retrieveUserCredentials = function (token) {
        var headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
        });
        var options = {
            headers: headers,
            responseType: "text",
            withCredentials: true,
        };
        return this.http.post(this.apiOK4 + signOnOk4, { token: token }, options);
    };
    AuthService.prototype.createAccessModel = function (token) {
        var _this = this;
        this.retrieveUserCredentials(token).subscribe(function (response) {
            var result = response.toString();
            var jsonError = result.indexOf("_Exception");
            var jsonStartIndex = result.indexOf("{");
            var jsonEndIndex = result.indexOf("</div>");
            if (jsonError < 0) {
                _this.authUser = JSON.parse(result.substring(jsonStartIndex - 1, jsonEndIndex - 1)).authUser;
                _this.sessionService.setAuthUser(_this.authUser);
                _this.authSubject.next(_this.authUser);
                _this.bootstrapService.bootstrap(token);
                _this.sessionService.setSessionState("true");
                _this.sessionService.setToken(token);
                _this.startIdleUserValidation();
            }
            else {
                _this.alertService.openInfoSessionModal(2, "br");
            }
        }, function (err) {
            _this.alertService.openInfoSessionModal(2, "br");
        });
        return true;
    };
    AuthService.prototype.invalidateAccessModel = function (shouldRedirect) {
        this.expireSession();
        if (shouldRedirect) {
            this.redirectToLogout();
        }
    };
    AuthService.prototype.retrieveAccessModel = function () {
        return this.sessionService.retrieveToken();
    };
    AuthService.prototype.validateAccessModel = function () {
        var token = this.sessionService.retrieveToken();
        if (token && this.sessionService.verifySessionState()) {
            if (!this.idleUserValidationHasStarted) {
                this.startIdleUserValidation();
            }
            return this.http.get(this.apiUrl + gestorTokenUrl + token, {
                withCredentials: true,
            });
        }
        this.sessionService.setSessionState("false");
        return null;
    };
    AuthService.prototype.closeConectionOk4 = function () {
        var headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
        });
        var options = { headers: headers, responseType: "text" };
        var currentUser = this.sessionService.getAuthUser();
        if (!currentUser ||
            !currentUser.name ||
            !currentUser.idConexao ||
            !currentUser.idSessao) {
            return Observable.create(function (obs) {
                obs.next(true);
                obs.complete();
            });
        }
        return this.http.post(this.apiOK4 + ok4Logout, {
            NomeUsuario: currentUser.name,
            Id: currentUser.idConexao,
            IdSessao: currentUser.idSessao,
        }, options);
    };
    AuthService.prototype.logout = function (shouldRedirect) {
        var _this = this;
        var invalid = false;
        this.closeConectionOk4().subscribe(function () {
            invalid = true;
            _this.invalidateAccessModel(shouldRedirect);
        }, function () {
            invalid = true;
            _this.invalidateAccessModel(shouldRedirect);
        }, function () {
            if (!invalid)
                _this.invalidateAccessModel(shouldRedirect);
        });
    };
    AuthService.prototype.openInvalidSessionModal = function () {
        this.alertService.openInfoSessionModal(1, "br");
    };
    AuthService.prototype.startIdleUserValidation = function () {
        this.userIdleService.startWatching();
        this.userIdleService.onTimerStart().subscribe();
        this.idleUserValidationHasStarted = true;
        this.idleUserOnTimeout();
        this.verifyIdleUser();
    };
    AuthService.prototype.expireSession = function () {
        this.sessionService.expireSession();
        this.userIdleService.stopTimer();
        this.userIdleService.stopWatching();
        this.idleUserValidationHasStarted = false;
    };
    AuthService.prototype.idleUserOnTimeout = function () {
        var _this = this;
        this.userIdleService.onTimeout().subscribe(function () {
            _this.logout(false);
            _this.openInvalidSessionModal();
        });
    };
    AuthService.prototype.authenticateOnOpenId = function () {
        location.assign(this.apiUrl + "/login");
    };
    AuthService.prototype.errorLogin = function () {
        this.alertService.openInfoSessionModal(2, "br");
    };
    AuthService.prototype.verifyIdleUser = function () {
        var _this = this;
        this.userIdleService.ping$.subscribe(function () {
            _this.pingSessionState();
        });
    };
    AuthService.prototype.pingSessionState = function () {
        var _this = this;
        var sessionExpired = this.sessionService.isSessionExpired;
        var sessionState = this.sessionService.verifySessionState();
        var idConexao = this.sessionService.getAuthUser() === null ||
            this.sessionService.getAuthUser() === undefined
            ? null
            : this.sessionService.getAuthUser().idConexao;
        if (!sessionExpired) {
            this.sessionService
                .getSessionState(this.sessionService.retrieveToken(), idConexao)
                .pipe(retryWhen(function (errors) {
                return errors.pipe(mergeMap(function (error, i) {
                    if (error.status === 500 && i < 10) {
                        return of(error);
                    }
                }));
            }))
                .subscribe(function (backSession) {
                _this.sessionService.setSessionState(sessionState.toString());
                if ((!sessionState && !sessionExpired) || !backSession) {
                    _this.expireSession();
                    _this.openInvalidSessionModal();
                }
            }, function () {
                _this.expireSession();
                _this.openInvalidSessionModal();
            });
        }
    };
    AuthService.prototype.getTokenFromURL = function (query, route) {
        var regex = new RegExp("[,;&\n]", "g");
        var param = "token=";
        if (route.fragment && !query) {
            var routeParam = route.fragment;
            return this.retrieveParameterList(routeParam, regex, param);
        }
        if (query && query.indexOf(param) >= 0) {
            return this.retrieveParameterList(query, regex, param);
        }
        return null;
    };
    AuthService.prototype.redirectToLogout = function () {
        var urlOpenId = this.environmentService.envModel.appSettings.apiUrlLogout;
        location.assign(urlOpenId);
    };
    Object.defineProperty(AuthService.prototype, "pathValue", {
        get: function () {
            return this.redirectUriPath;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.retrieveParameterList = function (content, regex, param) {
        var index = content.indexOf(param);
        var code = content.substring(index + 6);
        var list = code.split(regex);
        return list[0];
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.EnvironmentService), i0.inject(i2.HttpClient), i0.inject(i3.SessionService), i0.inject(i4.BootstrapService), i0.inject(i5.AlertService), i0.inject(i6.ItauUserIdleService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
